import React, { useState } from "react";
import { Box, IconButton, Popover, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import documentsIcon from "../../../assets/images/icons/documentsGridIcon.svg";
import { CloseRounded } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
interface NotePopoverRendererProps {
  value: string; // Il valore della stringa da visualizzare
}

const NotePopoverRenderer: React.FC<NotePopoverRendererProps> = ({ value }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const handleInfoClose = () => {
    setAnchorEl(null);
  };
  const { t } = useTranslation();
  return (
    <Box>
      <IconButton onClick={handleOpen} size="small" >
      {value && value.trim() !== "" && (
    <img src={documentsIcon} alt="Documents Icon" />
  )}
      </IconButton>
      <Popover
        elevation={1}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          borderWidth: "1px",
          borderColor: "primary.main",
        }}
      >
        <Box
          sx={{
            padding: 2,
            minWidth: 300,
            maxWidth: 400,
            minHeight: 120,
            position: "relative",
            borderWidth: "1px",
            borderColor: "primary.main",
            borderRadius: "10px",
            boxShadow: 10,
          }}
        >
          <IconButton
            onClick={handleInfoClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseRounded />
          </IconButton>
          <Typography
            variant="h6"
            sx={{ mb: 2, fontWeight: "bold", fontSize: "18px" }}
          >
            {t("screens.trips.notesCard.notes")}
          </Typography>
          <Typography variant="body2">{value}</Typography>
        </Box>
      </Popover>
    </Box>
  );
};

export default NotePopoverRenderer;
